<template>
  <div class="_mian">
    <div class="_top">
      <el-form :model="searchModel" inline>
        <el-form-item label="项目名称：">
          <el-input
            v-model="searchModel.projectName"
            placeholder="请输入项目名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="合同名称：">
          <el-input
            v-model="searchModel.contractName"
            placeholder="请输入合同名称"
          ></el-input>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" @click="searchBtn()">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="_btn">
      <el-button
        type="primary"
        size="medium"
        @click="projectInit()"
        style="margin-left: 20px"
      >
        + 项目立项
      </el-button>
    </div>
    <div class="_table">
      <el-table
        :data="projiectData"
        border
        v-loading="pageLoading"
        height="100%"
      >
        <el-table-column
          type="index"
          label="序号"
          width="100"
        ></el-table-column>
        <el-table-column prop="projectName" label="项目名称"></el-table-column>
        <el-table-column prop="managerName" label="项目经理"></el-table-column>
        <el-table-column prop="customTime" label="项目日期">
          <template slot-scope="scope">
            <span>
              {{
                formatDate(scope.row.startDate) +
                "-" +
                formatDate(scope.row.endDate)
              }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="status" label="立项状态">
          <template slot-scope="scope">
            <!-- <span v-if="scope.row.status == 0" style="color: magenta;">待提交</span>
                        <span v-else-if="scope.row.status == 1" style="color: green;">审批中</span>
                        <span v-else-if="scope.row.status == 2" style="color: gray;">已完成</span>
                        <span v-else-if="scope.row.status == 4" style="color: firebrick;">审批驳回</span>
                        <span v-else style="color: red;">已作废</span> -->
            <el-tag :type="getType(scope.row.status)" effect="plain">
              {{ getName(scope.row.status) }}
            </el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="applyName" label="立项人"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button
              type="text"
              size="medium"
              v-if="scope.row.status == 2"
              @click="openAddNewItem(scope.row)"
            >
              新增工作清单
            </el-button>
            <el-button
              type="text"
              size="medium"
              v-if="scope.row.status == 2"
              @click="projectDetail(scope.row)"
            >
              查看详情
            </el-button>
            <el-button
              type="text"
              size="medium"
              @click="projectDetail(scope.row)"
            >
              编辑
            </el-button>

            <el-button
              type="text"
              size="medium"
              @click="cancelFunc(scope.row)"
              v-if="adminInfo && scope.row.status === 2"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-dialog title="温馨提示" :visible.sync="dialogVisible" width="30%">
        <span style="font-size: 18px; font-weight: 700">确定删除此项目？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="ensureClick()">确 定</el-button>
        </span>
      </el-dialog>

      <!-- 新增工作清单弹窗 -->
      <add-new-item ref="addNewItem"></add-new-item>
    </div>
    <div class="_pageSelect">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="1"
        :page-sizes="[10, 50, 100]"
        :page-size="this.searchModel.size"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"
      ></el-pagination>
    </div>
  </div>
</template>

<script>
import ProjectApplyApi from "@/api/projectApply";
import TaskDispatchApi from "@/api/taskDispatch";
import AddNewItem from "./components/addNewItem.vue";
export default {
  components: {
    AddNewItem,
  },
  data() {
    return {
      dialogVisible: false,
      addNewItemVisible: false,
      currentProjectId: null,
      adminInfo: null,
      searchModel: {
        auditType: 0,
        contractName: "",
        current: 0,
        projectName: "",
        size: 10,
      },
      projiectData: [],
      totalCount: 0,
      pageLoading: false,
    };
  },
  methods: {
    cancelFunc(data) {
      this.dialogVisible = true;
      this.deleteId = data.id;
    },
    ensureClick() {
      TaskDispatchApi.projectDelete({ id: this.deleteId }).then((res) => {
        this.dialogVisible = false;
        this.queryProjectList(this.searchModel);
        if (res.data.code == 200) {
          this.$message.success(res.data.message);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    //身份校验
    getUserInfoName() {
      TaskDispatchApi.getUserInfo().then((res) => {
        if (res.data.code === 200) {
          this.adminInfo = res.data.data.sysAdmin;
        }
        console.log("-->>", this.adminInfo);
      });
    },
    formatDate(timestamp) {
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = ("0" + (date.getMonth() + 1)).slice(-2);
      const day = ("0" + date.getDate()).slice(-2);
      return `${year}.${month}.${day}`;
    },
    // 项目状态，0：待提交（暂存） 1：审批中 2：审批通过 3：审批驳回 4：已作废
    getName(status) {
      return {
        0: "待提交",
        1: "审批中",
        2: "已完成",
        3: "审批驳回",
        4: "已作废",
      }[status];
    },
    getType(status) {
      return {
        0: "success",
        1: "",
        2: "info",
        3: "warning",
        4: "danger",
      }[status];
    },
    handleSizeChange(val) {
      // console.log(`每页 ${val} 条`)
      this.searchModel.size = val;
      this.searchModel.current = 1;
      this.queryProjectList(this.searchModel);
    },
    handleCurrentChange(val) {
      // console.log(`当前页: ${val}`)
      this.searchModel.current = val;
      this.queryProjectList(this.searchModel);
    },
    async queryProjectList(params) {
      this.pageLoading = true;
      const res = await ProjectApplyApi.queryProjectList(params);
      this.projiectData = res.data.data.records;
      this.totalCount = res.data.data.total;
      this.pageLoading = false;
    },
    searchBtn() {
      this.queryProjectList(this.searchModel);
    },
    projectInit() {
      if (sessionStorage.getItem("type"))
        return sessionStorage.removeItem("type");
      this.$router.push("/projectApply");
    },
    projectDetail(row) {
      if (row.status === 0 || row.status === 4) {
        this.$router.push("/projectApply?id=" + row.id);
      } else {
        this.$router.push("/projectApplyDetail?id=" + row.id);
      }
    },
    // 打开新增工作清单弹窗
    openAddNewItem(row) {
      this.currentProjectId = row.id;
      this.$refs.addNewItem.open();
    },
  },
  created() {
    this.queryProjectList(this.searchModel);
    this.getUserInfoName();
  },
};
</script>
<style scoped>
._main {
  width: 100%;
  height: 100%;
  background-color: #fff;
}

._top {
  width: 100%;
  height: 60px;
  border-radius: 4px;
  /* padding-left: 20px; */
  padding-top: 10px;
}

._btn {
  display: flex;
  height: 60px;
  align-items: center;
}

.el-form-item {
  margin-left: 30px;
}

._table {
  padding: 10px;
  width: 100%;
  height: calc(100% - 180px);
  overflow-y: auto;
}

._pageSelect {
  height: 60px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding-right: 20px;
}
</style>

<style>
.el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  text-align: center;
}
</style>
